import {AxiosResponse} from 'axios'
import {GetRequest, LocationResponse} from './types'
import {HttpInstance} from '../createHttpInstance'

export interface GetNative<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const getNative: GetNative<GetRequest, LocationResponse> = (
  http,
  params,
) => {
  const {ClientID, ID} = params

  const path = '/v1/photos/{id}/native'.replace('{id}', ID.toString())

  return http.request<LocationResponse>({
    method: 'GET',
    url: `${path}?clientid=${ClientID}`,
  })
}
